export const SITE_SETTINGS = {
	name: 'Bookkeeping',
	froalaKey: 'SDB17hB8B6F4G4A4F3gKTRe2CG1PGe1DESAe1Kg1EBC1Pe2TKoF4I4B3A9A3B5A4B2A3F3==',
};
